import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FollowService {
  private isFollowing = new BehaviorSubject(false);
  private isProcessingFollow = new BehaviorSubject(false);
  private numWatching = new BehaviorSubject(0);

  isFollowing$ = this.isFollowing.asObservable();
  isProcessingFollow$ = this.isProcessingFollow.asObservable();
  numWatching$ = this.numWatching.asObservable();

  updateIsFollowing(follow: boolean) {
    this.isFollowing.next(follow);
  }

  updateProcessingFollow(isFollowing: boolean) {
    this.isProcessingFollow.next(isFollowing);
  }

  updateNumWatching(numWatching: number) {
    this.numWatching.next(numWatching);
  }
}
